<template>
  <v-card flat class="rounded-10">
    <v-card-title class="title-font">
      <v-icon class="mr-2">mdi-file-sign</v-icon>
      Terms & Conditions
    </v-card-title>
    <v-card-text>
      <v-card
        flat
        outlined
        class="rounded-10 overflow-y-auto"
        max-height="600px"
      >
        <v-card-text>
          <p>
            TERMS AND CONDITIONS OF SALE. These terms and conditions govern both
            the sale of Keystone Dental, Inc. products and digital access to the
            NEXUS Technology via the NEXUS Connect Lab Ordering Platform. As
            used herein, the term “Keystone” means Keystone Dental, Inc. and its
            applicable affiliates; the term “Products” means the Keystone
            products and services; and “Purchaser” or “Customer” means the
            person or company purchasing or accessing the Products or
            Technology.
          </p>
          DEFINITIONS:
          <div style="margin-left: 25px">
            <p>
              <strong>Appliances:</strong> The combination of NEXUS Frameworks
              and Overlays used to create full arch dental prostheses.
            </p>
            <p>
              <strong>Approved Intraoral Scanner:</strong> Any model of
              intraoral scanner approved by Keystone for use with the NEXUS
              Technology.
            </p>
            <p>
              <strong>NEXUS Frameworks (Unpolished):</strong> Precision-milled
              unpolished/unfinished metal bars produced using NEXUS Technology,
              designed to form part of full arch dental prostheses when combined
              with Overlays.
            </p>
            <p>
              <strong>NEXUS Scan Gauges:</strong> Proprietary, patented gauges
              that collect and record information regarding dental implants.
            </p>
            <p>
              <strong>Overlays:</strong> Teeth and associated gingiva combined
              with NEXUS Frameworks to create Appliances.
            </p>
            <p>
              <strong>Nexus Design Only:</strong> Refers to a process where
              scans provided by a distributor are used to generate a CAD design
              file. A design includes up to 3 revisions using the HTML review
              process. Additional changes or changes post-file upload requires a
              new submission.
            </p>
            <p>
              <strong>Nexus Abutment Export:</strong> Means a .STL/.PLY file
              that may be provided by Osteon through the Nexus Connect Portal to
              be used by the lab to create a full-arch prostheses design and/or
              to be incorporated in an Appliance for Temporary Use by an End
              User. Abutment exports require the correct library association
              steps to be performed by the Distributor, where incorrect gauge
              association will result in decreased accuracy and possible
              prosthetic misfit.
            </p>
            <p>
              <strong>Portal:</strong> The online platform provided by Keystone
              for accessing Technology, placing orders, and managing accounts.
            </p>
            <p>
              <strong>Customer Account:</strong> An account created by Purchaser
              on the Portal.
            </p>
            <p>
              <strong>NEXUS Technology:</strong> The patented and proprietary
              methods, processes, and software developed by Keystone for dental
              professionals.
            </p>
          </div>
          <p>
            AGREEMENT FORMATION. Use of Portal and acceptance of these Terms
            electronically constitutes a binding agreement between Purchaser and
            Keystone.
          </p>
          <p>
            GOVERNING TERMS. Any purchase and shipment of Products shall be
            deemed to be on the terms and conditions stated herein. Any and all
            terms and conditions submitted by the Purchaser are hereby rejected.
          </p>
          <p>
            TAXES. The prices set forth herein do not include any sales, use,
            excise, ad valorem, property or other taxes applicable to the sale,
            use or delivery of the Products, all of which shall be paid by
            Purchaser separately or added to the contract price and paid by
            Purchaser to Keystone.
          </p>
          <p>
            PRICES. The prices set forth for the Products are in local currency.
            All prices shall be as of the invoice date, regardless of the date
            the Product is originally ordered from Keystone. Keystone reserves
            the right to increase prices with 60 days notice.
          </p>
          <p>
            DELIVERY. Title to and risk of loss for the Products subject to a
            purchase order shall shift from Keystone to Purchaser upon
            Keystone's delivery of the goods to the carrier. Products sold
            hereunder shall be delivered F.O.B. shipping point. Purchaser shall
            assume responsibility for all subsequent delivery or shipping
            charges.
          </p>
          <p>
            ACCEPTANCE. Purchaser must inspect all Products for defects and/or
            non-conformity and notify Keystone of any such defect and/or
            non-conformity within seven (7) calendar days of delivery. After
            this period, Purchaser will have accepted such Products subject to
            Purchaser's right of return set forth in the “RETURN; EXCHANGE”
            section below.
          </p>
          <p>
            PAYMENT. Payment shall be made using a valid credit card at time of
            purchase. If any payment is late, interest shall accrue on the
            amount due and unpaid from the date such payment was due until paid
            at an interest rate equal to 1 1/4% per month or the maximum
            interest rate permitted under applicable law, whichever is less.
            Keystone may, in its sole discretion, suspend shipments of Products
            until full payment by Purchaser of all past due amounts to Keystone
            is made. Purchaser acknowledges and agrees that it shall pay all
            costs of collection, including, without limitation, reasonable
            attorneys' fees, incurred by Keystone in connection with collecting
            any sums due Keystone, including but not limited to, any incidental
            or consequential damages to Keystone arising from Purchaser's
            failure to satisfy its obligations hereunder. PURCHASER WAIVES ANY
            RIGHT OF SET-OFF AND SHALL MAKE NO DEDUCTIONS FROM PAYMENTS DUE TO
            KEYSTONE FOR ANY DAMAGES OF ANY TYPE CLAIMED BY PURCHASER AGAINST
            KEYSTONE.
          </p>
          <p>
            RETURN; EXCHANGE. Purchaser may return any Product (excluding
            Products that are custom made, patient matched prosthesis, and
            gauges) within thirty (30) calendar days of the invoice date so long
            as there is an offsetting (exchange) order of equal or greater
            value. Purchaser may return any Product after thirty (30) calendar
            days from the invoice date, but no later than ninety (90) calendar
            days after the invoice date, so long as there is an offsetting
            (exchange) order of equal or greater value, provided, however, such
            returns shall be subject to a 15% restocking fee. Keystone will not
            accept any returns or exchanges after ninety (90) calendar days
            following the invoice date. Products that are custom made, patient
            matched prosthesis will be accepted for return only when there is a
            defect in materials or workmanship or if the Product does not match
            any special instructions communicated in relation to the Product in
            question and Purchaser has timely notified Keystone of any such
            defect or non-conformity within the time required by the
            “ACCEPTANCE” section set forth above. No biomaterial products (bone
            grafting and membrane) will be accepted for return or exchange. No
            returns or exchanges will be accepted for Products that (i) were
            originally sold as part of a kit, pack or set, (ii) were included on
            the original invoice at no charge, (iii) have less than six (6)
            months remaining before expiration or (iv) were custom ordered. The
            Purchaser shall pay all shipping costs associated with the return or
            exchange of a Product. No Products will be accepted by Keystone for
            return or exchange without an RMA number given to Purchaser by
            Keystone Customer Service. Returned Products must be unexpired, un-
            opened and undamaged, returned freight prepaid.
          </p>
          <p>
            LIFETIME IMPLANT WARRANTY PROGRAM AND OSTEON WARRANTY PROGRAM AS IN
            EFFECT ON THE DATE OF INVOICE FOR THE APPLICABLE PRODUCTS AND ONLY
            TO THE EXTENT APPLICABLE TO SUCH PRODUCTS, KEYSTONE DOES NOT MAKE
            ANY WARRANTY, EXPRESS OR IMPLIED, EXCEPT THAT ITS PRODUCTS SHALL BE
            FREE FROM DEFECTS IN MATERIAL AND/OR WORKMANSHIP. THIS WARRANTY
            APPLIES ONLY TO THE ORIGINAL PURCHASER. PURCHASER ASSUMES ALL RISKS
            AND LIABILITY RESULTING FROM THE USE OF THESE PRODUCTS, WHETHER USED
            SEPARATELY OR IN COMBINATION WITH OTHER PRODUCTS. THE WARRANTY DOES
            NOT APPLY IF THE FAILURE OF THE PRODUCT IS CAUSED BY TRAUMA OR
            ACCIDENT OR BY THE PATIENT IN WHOM THE IMPLANT OR PRODUCT WAS
            INSTALLED OR IF THE PURCHASER IS NOT CURRENT ON ALL OUTSTANDING
            PAYMENTS TO KEYSTONE AT THE TIME OF SUCH CLAIM. KEYSTONE MAY MODIFY
            OR TERMINATE ITS WARRANTY PROGRAM AT ANY TIME, HOWEVER ANY CHANGES
            TO THE WARRANTY PROGRAM WILL NOT AFFECT PRODUCTS ALREADY PURCHASED
            AT THE TIME OF SUCH CHANGE. PURCHASER'S SOLE REMEDY WITH RESPECT TO
            CLAIMS RELATED TO KEYSTONE PRODUCTS IS RESTRICTED TO THE APPLICABLE
            WARRANTY POLICIES. PURCHASER ACKNOWLEDGES THAT IT IS NOT RELYING ON
            KEYSTONE'S SKILL OR JUDGMENT TO SELECT OR FURNISH PRODUCTS SUITABLE
            FOR ANY PARTICULAR PURPOSE. <strong>FOR NEXUS FRAMEWORKS:</strong> A
            LIMITED LIFETIME WARRANTY APPLIES FOR END-USERS, COVERING
            MANUFACTURING DEFECTS. THIS WARRANTY IS SPECIFICALLY LIMITED TO THE
            FIT OF THE FRAMEWORK ON THE PRINTED MODEL CREATED BASED ON THE TOOTH
            DESIGN SUBMITTED AT THE TIME OF THE ORDER. KEYSTONE SHALL NOT BE
            LIABLE FOR ANY FIT ISSUES THAT ARISE DUE TO CHANGES MADE OUTSIDE OF
            THIS DESIGN SCOPE OR DISCREPANCIES FROM THE SUBMITTED DESIGN.
            REMEDIES INCLUDE REPLACEMENT, REPAIR, OR REFUND AT KEYSTONE'S
            DISCRETION. EXCLUSIONS INCLUDE MISUSE, EXTERNAL DAMAGE, OR
            UNAUTHORIZED MODIFICATIONS.
          </p>
          <p>
            <strong>DESIGN-ONLY ORDERS:</strong> A DESIGN-ONLY ORDER INCLUDES UP
            TO THREE (3) DIGITAL REVISIONS, USING THE HTML REVIEW PROCESS AND
            THE CASE NOTES/CHAT FUNCTION. ONCE A DESIGN HAS BEEN UPLOADED IN
            PRINTABLE OR WORKABLE FORMAT (.STL / .PLY) THE CASE WILL BE CLOSED
            AND NO FURTHER CHANGES CAN BE MADE. ADDITIONAL CHANGES REQUIRE A NEW
            DESIGN ONLY ORDER TO BE SUBMITTED.
          </p>
          <p>
            LIMITATION OF LIABILITY. UNDER NO CIRCUMSTANCES SHALL KEYSTONE OR
            ANY OF ITS AFFILIATES BE LIABLE FOR BUSINESS INTERRUPTION, LOSS OF
            PROFITS, SPECIAL, INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES OF
            ANY NATURE AND FROM ANY CAUSE WHETHER BASED IN CONTRACT, WARRANTY OR
            TORT (INCLUDING NEGLIGENCE) OR OTHER LEGAL THEORY, EVEN IF KEYSTONE
            HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          </p>
          <p>
            INTELLECTUAL PROPERTY. All intellectual property rights in Products
            sold to Purchaser shall remain the exclusive property of Keystone.
          </p>
          <p>
            PERSONAL DATA. It is Purchaser's responsibility to obtain patient's
            consent to transfer any personal data to Keystone. Purchaser shall
            comply with all applicable laws and regulations related to the
            transfer of such personal data and shall in no event transmit any
            such personal data without the prior written consent of Keystone and
            without appropriately marking the personal data so that the
            confidential nature of such personal data is apparent to Keystone.
          </p>
          <p>
            TERMINATION. Keystone may terminate this or any agreement with
            Purchaser to purchase its Products upon immediate written notice if
            Purchaser fails to pay any of its obligations to Keystone on time.
          </p>
          <p>
            FORCE MAJEURE. Keystone shall not be liable for any loss or damage
            due to failure or delay arising out of any cause beyond the
            reasonable control of Keystone. In the event of any failure or delay
            resulting from such causes, an equitable adjustment of delivery and
            any other appropriate terms and conditions shall be made. No such
            failure or delay shall be the basis for an increase in Keystone's
            obligations, nor any termination by Purchaser.
          </p>
          <p>
            CONDITION AND QUANTITY OF GOODS. Keystone reserves the right to make
            any change in material or its designs which is minor or an
            improvement with or without prior notice, but bears no obligation to
            do so. Any design, specification, or other change requested by
            Purchaser shall be made only as agreed to in writing by Keystone.
            Keystone makes no warranty or representation of any nature that any
            Products shipped to Purchaser conform to any goods of like Product
            description as may have previously been delivered to Purchaser
            except as to the applicable specifications. All Products shall be
            subject to standard manufacturing and commercial variations and
            practices of Keystone. If Keystone should be manufacturing any
            "non-standard" Product for Purchaser, and Purchaser requests a delay
            or a delay is caused by lack of shipping instructions from
            Purchaser, then Keystone will store all items ordered at Purchaser's
            risk and expense and will invoice Purchaser for the full purchase
            price of the Products on or after the date on which same are ready
            for delivery. If manufacture is delayed by Purchaser, payment shall
            be made based on the percentage of completion and the purchase
            price.
          </p>
          <p>
            IDENTIFICATION OF PRODUCTS AND TRADEMARKS. Keystone may, at
            Keystone's option, place its name, address and trademark on the
            Products or any component thereof that are purchased from Keystone.
          </p>
          <p>
            CANCELLATION: No orders may be cancelled or changed without the
            written agreement of both parties. In the event Purchaser cancels or
            repudiates a purchase order after acceptance by Keystone, Purchaser
            shall pay liquidated damages to Keystone as follows: (a) If the
            goods have been manufactured and are ready for shipment at the time
            Purchaser cancels or repudiates the purchase order, Purchaser shall
            pay the full purchase price. (b) If the manufacture of the goods has
            not been completed at the time Purchaser cancels or repudiates the
            purchase order, Purchaser shall pay to Keystone (i) all costs
            incurred by Keystone pursuant to Keystone's obligations under the
            purchase order up to the time notice of said cancellation is
            received by Keystone; (ii) all other costs subsequently incurred by
            Keystone that cannot be avoided; and (iii) the expected profit of
            Keystone if Keystone had completed manufacture of the goods and
            delivered same to Purchaser.
          </p>
          <p>
            CREDIT APPROVAL; ADEQUATE ASSURANCE; SECURITY INTEREST. All purchase
            orders are subject to credit approval of Purchaser and to acceptance
            by Keystone. During the performance of Keystone's obligations,
            Keystone shall have the right to demand adequate assurance of due
            performance if reasonable uncertainty exists concerning Purchaser's
            solvency or if Purchaser has become incapacitated, declared
            bankruptcy, suspended payments or, in the case of a corporation,
            dissolved, and Keystone may suspend further performance until such
            assurance is given by Purchaser or, at Keystone's sole option, may
            terminate the purchase order in which event Keystone shall be
            entitled to receive from Purchaser liquidated damages determined in
            accordance with the “CANCELLATION” section set forth above or such
            amount as is then due and owing from Purchaser to Keystone for such
            Products, whichever is greater. Purchaser hereby grants to Keystone,
            and its successors and assigns, a security interest in all Products
            until all amounts due or to become due under the purchase order have
            been paid, and agrees, without further consideration, to execute and
            deliver all documents reasonably requested by Keystone to perfect
            its security interest.
          </p>
          <p>
            <strong>EXPORT SALES.</strong> Purchaser shall comply with all
            applicable laws, rules, and regulations of all jurisdictions have a
            relation to the purchase and movement of, and payment for, any
            Products Keystone may sell or otherwise provide to Purchaser, and
            Purchaser will not import, export or transfer any products sold or
            provided by Keystone without obtaining all necessary or required
            governmental or other authorizations or approvals or otherwise
            complying with all applicable legal requirements and payment of any
            duties on such Products.
          </p>
          <p>
            DISCOUNT REPORTING OBLIGATIONS. If the pricing offered to Purchaser
            hereunder constitutes “a discount or other reduction in price” for
            purposes of the federal Anti-Kickback Statute (“AKS”) discount
            exception (42 U.S.C. §1320a-7b(b)(3)(A)) and the AKS discount safe
            harbor (42 C.F.R. §1001.952(h)), Purchaser shall disclose the
            discount or reduction in price to the full extent required under any
            state or federal program that provides cost or charge-based
            reimbursement to Purchaser for Products. Purchaser may also be
            required, upon request, to provide documentation of the discount or
            other reduction in price to the Secretary of the Department of
            Health and Human Services and/or state agencies. Purchaser shall
            make written request to Keystone if Purchaser requires additional
            information from Keystone to meet its reporting requirements.
          </p>
          <p>
            VALIDITY. If any provision of these Terms and Conditions is found to
            be illegal or unenforceable in any respect, such illegality or
            unenforceability shall not affect any other provision of these Terms
            and Conditions, all of which shall remain enforceable in accordance
            with their terms.
          </p>
          <p>
            NO THIRD PARTY BENEFICIARIES. The purchase order shall be for the
            sole and exclusive benefit of Keystone and Purchaser and not for the
            benefit of any other person or entity.
          </p>
          <p>
            GENERAL PROVISIONS. The purchase of the Products and these Terms and
            Conditions are governed by the laws of the Common- wealth of
            Massachusetts, without regard to conflicts of law principles. Any
            dispute, claim or controversy arising out of or in connection with
            the purchase of the Products shall be resolved by arbitration in
            Boston, Massachusetts. This document incorporates all oral and
            written representations between the parties and constitutes the
            entire agreement and understanding of the parties with respect to
            the subject matter hereof and supersedes any and all other
            agreements either oral or written between the parties with respect
            to such subject matter. No amendment or modification may be made to
            this document unless in writing and duly executed by an authorized
            representative of Keystone. No waiver by Keystone of any breach of
            these terms and conditions by Purchaser shall constitute a waiver of
            any other breach or of such provision. Keystone's failure to require
            strict performance of any term or provision hereof shall not affect
            Keystone's right thereafter to require strict performance of such
            term or provision or any other term or provision hereof. Keystone's
            failure to object to provisions contained in any communication from
            Purchaser shall not be deemed an acceptance of such provisions or a
            waiver of these terms and conditions. Keystone may subcontract,
            assign or transfer its obligations or rights to a competent third
            party. Purchaser may not assign or transfer any of its obligations
            without the prior written consent of Keystone.
          </p>
        </v-card-text>
      </v-card>
      <v-row>
        <v-col cols="12" class="d-flex">
          <v-checkbox
            v-model="acceptTerms"
            label="I accept and agree to the Terms & Conditions above"
            class="ml-auto"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn class="btn-error rounded-10 mr-2" @click="cancel()">Cancel</v-btn>
      <v-btn
        :disabled="!acceptTerms"
        class="btn-primary rounded-10"
        @click="accept()"
      >
        Continue
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style lang="css" scoped></style>

<script>
export default {
  name: "TermsAndConditions",

  props: ["value"],

  computed: {
    acceptTerms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      }
    }
  },

  methods: {
    accept() {
      this.$emit("accept", true)
    },

    cancel() {
      this.$emit("cancel", true)
    }
  }
}
</script>
